import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {SharedSettings} from "@shared/models/shared-settings";
import {Employee} from "@shared/models/employee";
import {url} from "@shared/helpers/url";
import {map, Observable} from "rxjs";
import {DateTime} from "luxon";

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

    constructor(private http: HttpClient,
                private settings: SharedSettings) { }

    getEmployeesBySiteDate(siteId: string, date: DateTime): Observable<Employee[]> {
        return this.http.get<Employee[]>(this.settings.apiBaseUrl + url`employees/${siteId}/${date.toISODate()}`)
            .pipe(map(employees => employees.map(this.calcDisplayName)));
    }

    getEmployeesBySite(siteId: string): Observable<Employee[]> {
        return this.http.get<Employee[]>(this.settings.apiBaseUrl + url`employees/${siteId}`)
            .pipe(map(employees => employees.map(this.calcDisplayName)));
    }



    private calcDisplayName(emp: Employee): Employee {
        if (emp)
            emp.fullName = `${emp.fileNumber} - ${emp.firstName} ${emp.lastName}`;

        return emp;
    }
}
